const RETRIES_LEFT = 3;
const INTERVAL = 500;
export const retry = (createPromise, options = {}) => {
    let { retries = RETRIES_LEFT } = options;
    const { timeout = INTERVAL, shouldRetry = () => true, signal } = options;
    const callPromise = (...args) => createPromise(...args).catch((error) => {
        if (--retries < 1 || !shouldRetry(error)) {
            throw error;
        }
        return wait(timeout, signal).then(() => callPromise(...args));
    });
    return (...args) => callPromise(...args);
};
export const wait = (timeout, signal) => new Promise((resolve, reject) => {
    const timeoutId = window.setTimeout(resolve, timeout);
    signal?.addEventListener('abort', () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        reject(new DOMException('The user aborted a timeout.', 'AbortError'));
    });
});
export const waitForTarget = (getTarget, timeout = Infinity) => new Promise((resolve, reject) => {
    const limit = Date.now() + timeout;
    function tick() {
        const target = getTarget();
        if (target) {
            resolve(target);
            return;
        }
        if (Date.now() > limit) {
            reject(new Error('Waiting time is over'));
            return;
        }
        setTimeout(() => tick(), 100);
    }
    tick();
});
